var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: [_vm.enter ? "show" : ""] },
    [
      _c("TopWaypoints", {
        on: {
          enterdown: _vm.enterDown,
          exitup: _vm.exitUp,
          out: _vm.outDown,
          in: _vm.inUp,
        },
      }),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _c("BottomWaypoints", {
        on: {
          enterup: _vm.enterUp,
          exitdown: _vm.exitDown,
          out: _vm.outUp,
          in: _vm.inDown,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }